<template>
  <div class="input-number-big">
    <button type="button" @click="decreaseValue()" :disabled="disabled || value <= min">-</button>
    <input type="number" :step="step" :min="min" :max="max" v-model="value" class="input_number" />
    <button type="button" @click="increaseValue()" :disabled="disabled || value >= max">+</button>
  </div>
</template>

<script setup lang="ts">
const value = defineModel<number>("value", { default: 0 });
const { min = 0, max = Infinity, step = 1, disabled = false } = defineProps<{
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
}>();

function decreaseValue() {
  value.value = Math.max(min, value.value - step);
}

function increaseValue() {
  value.value = Math.min(max, value.value + step);
}
</script>

<style lang="scss">
.input-number-big {
  display: grid;
  grid-template-columns: min-content minmax(0, 1fr) min-content;
  align-items: center;
  border-radius: 0.25rem;
  overflow: hidden;
  position: relative;

  &::after {
    content: "";
    display: block;
    position: absolute;
    box-shadow: inset 0 1px 3px 1px var(--color-shadow-2);
    pointer-events: none;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  & > button {
    padding: 0.5rem;
    font-size: 1.5rem;
    cursor: pointer;
    background: none;
    border: none;
    width: 2em;
    font-weight: bold;
    transition: background-color 200ms;
    &:hover {
      background: var(--color-background-medium);
    }
  }

  & > input {
    display: block;
    border: none;
    text-align: center;
    font-size: 1.5rem;
    height: 100%;
    background: none;
    
    &:focus {
      outline: none;
    }
  }
}
</style>